import * as React from "react"; // tslint:disable-line
import styled from "styled-components";

const FormWrapper = styled.div`
  font-family: "Mulish", "Inter", sans-serif;
  margin-bottom: 24px;
  .ant-radio-button-wrapper-checked {
    background-color: ${(props) => props.theme.blue};
    color: #fff;
    span {
      color: #fff;
      &:hover {
        color: #fff;
      }
    }
  }
  .ant-radio-group {
    display: flex;
    label {
      flex: 1;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .ant-form {
    font-family: "Mulish", "Inter", sans-serif;
    margin-bottom: -16px;
    label {
      font-family: "Mulish", "Inter", sans-serif;
      z-index: 0;
      font-size: ${(props) => props?.theme?.fontSize?.body};
    }
    legend {
      margin-bottom: 8px;
      color: ${(props) => props.theme.textColor};
      border: none;
      font-size: ${(props) => props?.theme?.fontSize?.title3};
    }
    .ant-input {
      font-size: ${(props) => props?.theme?.fontSize?.body};
      font-weight: 400;
      &:not(textarea) {
        height: 40px;
      }
      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px white inset;
      }
    }
    .ant-form-item {
      font-family: "Mulish", "Inter", sans-serif;
      font-weight: 400;
      margin-bottom: 16px;
    }
    .ant-select {
      .ant-select-selection--single {
        height: 40px;
        font-size: ${(props) => props?.theme?.fontSize?.body};
        font-weight: 400;
      }
      .ant-select-selection__rendered {
        line-height: 40px;
      }
    }
    .ant-form-item-control {
      line-height: normal;
    }
    .ant-form-explain {
      margin-top: 4px;
      font-size: ${(props) => props?.theme?.fontSize?.caption};
      font-weight: 400;
      color: ${(props) => props.theme.textDeepGray};
    }
    .has-error {
      input {
        border-color: #f5222d;
      }
      .ant-form-explain {
        margin-top: 4px;
        color: #f5222d;
      }
    }
    .ant-form-item-label {
      label {
        line-height: 2;
        color: ${(props) => props.theme.textColor};
        &::after {
          content: none;
        }
        &.ant-form-item-required {
          &::before {
            content: none;
          }
          &::after {
            content: "*";
            color: ${(props) => props.theme.redBase};
          }
        }
      }
      @media (max-width: 575px) {
        .ant-form-item-required {
          &::after {
            display: inline;
          }
        }
      }
    }
    .ant-input-number-input {
      height: 38px;
      line-height: 24px;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
    .normal-radio {
      display: block;
      label {
        flex: none;
      }
    }
    .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
      margin-top: 8px;
    }
    .ant-upload.ant-upload-select-picture-card {
      width: 100%;
      height: 100%;
      margin: 0;
      border-radius: 0;
    }
  }
`;

export { FormWrapper };
